import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import ModalContainer from "./../../ModalContainer";
import { FileUploader } from "react-drag-drop-files";
import { useFormik } from "formik";
import * as yup from "yup";
import useFileUpload from "../../../../utils/hooks/useFileUpload";
import {
  addOtherDocs,
  setApplicationInfo,
} from "../../../../redux/slice/customer/customerSlice";
// import { useLocation } from 'react-router-dom';
import { useRef } from "react";
import { flashMessage } from "./../../../../utils/flash/index";

const MoreDocument = ({ modal_id, modal_width, data }) => {
  const { fileUrl, setFileUrl, singleFileUpload } = useFileUpload();
  const [isUploading, setIsUploading] = useState(false);
  const fileTypes = ["JPG", "PNG", "PDF", "DOC", "DOCX"];
  let closeRef = useRef("");

  const dispatch = useDispatch();
  // const location = useLocation();

  const onSubmit = (values, { resetForm }) => {
    if (!fileUrl) {
      flashMessage("error", "please upload document");
    } else if (data) {
      let payload = {
        other_doc_name: values.other_document_name,
        other_doc_url: fileUrl,
        customer_id: data.customer_id,
        id: data.id,
      };
      dispatch(addOtherDocs(payload));
      closeRef.current.click();
    } else {
      let other_doc = {
        other_document_name: values.other_document_name,
        other_document_url: fileUrl,
      };
      dispatch(setApplicationInfo({ other_doc: other_doc }));
      setFileUrl("");
      resetForm();
      flashMessage("success", "document added");
      // closeRef.current.click()
    }
  };

  const documentSchema = yup.object().shape({
    other_document_name: yup
      .string()
      .max(15, "document name can only be 15 characters")
      .required("please enter document name"),
  });

  const { values, errors, handleBlur, handleChange, handleSubmit, touched } =
    useFormik({
      initialValues: {
        other_document_name: "",
      },
      validationSchema: documentSchema,
      onSubmit,
    });

  const handleFileChange = (file) => {
    setIsUploading(true);
    singleFileUpload(file);
  };

  useEffect(() => {
    if (fileUrl) {
      setIsUploading(false);
      // let other_doc = {
      //   other_document_name: values.other_document_name,
      //   other_document_url: fileUrl
      // }
      // dispatch(setApplicationInfo({other_doc: other_doc}))
    }
  }, [fileUrl]);

  return (
    <ModalContainer
      modal_id={modal_id}
      modal_width={modal_width}
      bradius='rounded-0'
    >
      <div className='container pb-3 pt-2'>
        <form onSubmit={handleSubmit}>
          <div className='my-3'>
            <div className='row'>
              <div className='col-md-7'>
                <input
                  type='text'
                  name='other_document_name'
                  id='other_document_name'
                  onChange={handleChange}
                  value={values.other_document_name}
                  onBlur={handleBlur}
                  placeholder='Enter document name'
                  className={`form-control ${
                    errors.other_document_name &&
                    touched.other_document_name &&
                    "is-invalid"
                  } p-2`}
                />
                {errors.other_document_name && touched.other_document_name && (
                  <span className='invalid-feedback'>
                    {errors.other_document_name}
                  </span>
                )}
              </div>
              <div className='col-md-4 mx-auto '>
                <FileUploader
                  label=' Browse Document'
                  children={
                    <div
                      className='borde border-dotted p-1 px-4 text-center cursor-p'
                      style={{ border: "2px dashed grey" }}
                    >
                      <i className='uil uil-cloud-upload fs-4'></i> Upload
                      Document<span className='text-primary-dark mt-0'></span>
                      {/* {selectedFile == "cert_incorp_url" &&
                        isUploading &&
                        !businessDocuments.cert_incorp_url && (
                          <span>
                            {" "}
                            <i className='mdi mdi-dots-circle mdi-spin'></i>{" "}
                          </span>
                        )} */}
                    </div>
                  }
                  handleChange={handleFileChange}
                  // onDrop={handleChange}
                  name='file'
                  types={fileTypes}
                />
                {isUploading && (
                  <span>
                    uploading <i className='mdi mdi-dots-circle mdi-spin'></i>
                  </span>
                )}
                {!isUploading && fileUrl && (
                  <span className='text-success'>
                    uploaded <i className='mdi mdi-check'></i>
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className='d-flex justify-content-between mt-4'>
            <p
              ref={closeRef}
              className='btn btn-secondary px-4'
              data-bs-dismiss='modal'
            >
              Close
            </p>
            <div className='d-grid'>
              <button
                className='btn bg-primary-1 text-white px-4 rounded-2'
                type='submit'
              >
                Add Document
              </button>
            </div>
          </div>
        </form>
      </div>
    </ModalContainer>
  );
};

export default MoreDocument;
